
const fn = async () => {
  return 'readFn'
}

export default fn
